import { Component, Input, Output, EventEmitter, effect, inject, OnInit,ViewChild,ElementRef } from '@angular/core';
import { AppSettings } from '@services/settings/app-settings.service';
import { MicrosoftAuthService } from '@services/core/authentication.service';
import { UserService } from '@services/core/user.service';
declare var slideToggle: any;
import { environment } from '../../../environments/environment';

@Component({
	selector: 'header',
	templateUrl: './header.component.html',
	styleUrls: ["./header.component.css"],
	standalone: true,
})
export class HeaderComponent implements OnInit{
	@Input() appSidebarTwo;
	@Output() appSidebarEndToggled = new EventEmitter<boolean>();
	@Output() appSidebarMobileToggled = new EventEmitter<boolean>();
	@Output() appSidebarEndMobileToggled = new EventEmitter<boolean>();
	@ViewChild('entityFilter') entityFilter!: ElementRef<HTMLInputElement>;
	protected logo = "assets/img/logo.webp"
	protected profilePhotoURL
	protected userData
	public entities = []
	public entitiesTemp = []
	public budgetVersionSelected;
	public budgetFund;
	public appSettings = inject(AppSettings)
	private userService = inject(UserService)
	private authMicrosoft = inject(MicrosoftAuthService)
	entitySelected;
	environment=environment;
	year ;
	version ;
	public fundSelect;
	toggleAppSidebarMobile() {
		this.appSidebarMobileToggled.emit(true);
	}

	toggleAppSidebarEnd() {
		this.appSidebarEndToggled.emit(true);
	}

	toggleAppSidebarEndMobile() {
		this.appSidebarEndMobileToggled.emit(true);
	}

	toggleAppTopMenuMobile() {
		var target = document.querySelector('.app-top-menu');
		if (target) {
			slideToggle(target);
		}
	}

	toggleAppHeaderMegaMenuMobile() {
		this.appSettings.appHeaderMegaMenuMobileToggled = !this.appSettings.appHeaderMegaMenuMobileToggled;
	}



	constructor(){

		effect(()=> {
			this.entities = this.userService.sharingEntities()
			let entitySelected = this.userService.sharingEntity()
			this.entitiesTemp =JSON.parse(JSON.stringify(this.entities))
			this.userData = this.userService.userData()
			this.profilePhotoURL = this.userService.userPhoto()
			this.budgetVersionSelected = this.userService.sharingBudgetVersion();
			const budgetFundData = this.userService.sharingBudgetFund();
       		if (this.budgetVersionSelected?.year) { 
				this.entitySelected = entitySelected 
				this.entitiesTemp = this.entities     
        		this.year = this.budgetVersionSelected.year;
        		this.version = this.budgetVersionSelected.version; 
				this.budgetFund = budgetFundData;
				this.fundSelect = this.budgetFund[0]?.fundCode;
      }
		})
	}

	ngOnInit(): void {
		
	}
	
	logout() {
		this.authMicrosoft.clearSesion()
		this.authMicrosoft.logout().subscribe(res => {
			let a = document.createElement('a')
			a.href = res.url
			a.click()
		})
	}

	cambiaentidad(entity){
		if (entity?.code != this.entitySelected?.code) {			
		this.userService.changeEntity(entity).subscribe(res=>{
			this.entitySelected = entity;
			this.userService.sharingEntity.set(entity);
			this.userService.refreshBudgetVersion().subscribe({
				
			  });;
		})
	}

	}

	filtrarEntidades(	){
		const find = this.entityFilter.nativeElement.value?.toLowerCase()
		this.entities = this.entitiesTemp.filter(entity => 
			entity.name.toLowerCase().includes(find)	|| 
			entity.code.toString().includes(find) || 
			entity.group.toLowerCase().includes(find) || 
			entity.campus.toLowerCase().includes(find)
		)
	}
}
